import script from "./PWAInstallPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./PWAInstallPrompt.vue?vue&type=script&setup=true&lang=js"

import "./PWAInstallPrompt.vue?vue&type=style&index=0&id=cde45784&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cde45784"]])

export default __exports__